import Colors from 'modules/Colors';
import { CSSProperties, SVGProps } from 'react';

interface DeezerPlatformIconProps extends SVGProps<SVGSVGElement> {
    className?: string;
    style?: CSSProperties;
    color?: string;
    size?: number;
    onClick?: () => void;
}

const DeezerPlatformIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 52,
    onClick,
}: DeezerPlatformIconProps) => (
    <svg
        className={className}
        style={style}
        width={size}
        onClick={onClick}
        viewBox="0 0 92 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24.4303 22.1503C24.4303 25.4786 26.4804 27.4706 29.5265 27.4706C31.0454 27.4706 32.3236 27.0473 33.0374 25.9351V27.4706H35.8179V11.6176H32.9295V18.3572C32.2738 17.245 31.062 16.747 29.5431 16.747C26.5717 16.7387 24.4303 18.7722 24.4303 22.1503ZM33.0208 22.1503C33.0208 24.051 31.726 25.2379 30.1739 25.2379C28.5637 25.2379 27.327 24.051 27.327 22.1503C27.327 20.2164 28.572 19.0046 30.1739 19.0046C31.726 19.0046 33.0208 20.233 33.0208 22.1503ZM44.8068 23.3787C44.4748 24.6071 43.6365 25.2213 42.3168 25.2213C40.7813 25.2213 39.5197 24.2917 39.4865 22.6483H46.7656C46.8569 22.2416 46.8984 21.81 46.8984 21.3369C46.8984 18.3904 44.8898 16.7304 41.9267 16.7304C38.7644 16.7304 36.5898 18.9797 36.5898 22.0341C36.5898 25.4371 38.9885 27.4789 42.3085 27.4789C44.8151 27.4789 46.5166 26.4331 47.2636 24.3498L44.8068 23.3787ZM39.4865 20.7227C39.7604 19.5358 40.7481 18.8386 41.935 18.8386C43.2298 18.8386 44.1096 19.5358 44.1096 20.6314L44.093 20.7227H39.4865ZM55.5221 23.3787C55.1901 24.6071 54.3518 25.2213 53.0321 25.2213C51.4966 25.2213 50.235 24.2917 50.2018 22.6483H57.4809C57.5722 22.2416 57.6137 21.81 57.6137 21.3369C57.6137 18.3904 55.6051 16.7304 52.642 16.7304C49.4797 16.7304 47.3051 18.9797 47.3051 22.0341C47.3051 25.4371 49.7038 27.4789 53.0238 27.4789C55.5304 27.4789 57.2319 26.4331 57.9789 24.3498L55.5221 23.3787ZM50.2018 20.7227C50.4757 19.5358 51.4634 18.8386 52.6503 18.8386C53.9451 18.8386 54.8249 19.5358 54.8249 20.6314L54.8083 20.7227H50.2018ZM67.8061 27.4872V24.8727H61.7388L67.6401 19.1291V16.7387H58.3026V19.2287H64.0047L58.12 24.9972V27.4872H67.8061ZM76.2472 23.3787C75.9152 24.6071 75.0769 25.2213 73.7572 25.2213C72.2217 25.2213 70.9601 24.2917 70.9269 22.6483H78.206C78.2973 22.2416 78.3388 21.81 78.3388 21.3369C78.3388 18.3904 76.3302 16.7304 73.3671 16.7304C70.2048 16.7304 68.0302 18.9797 68.0302 22.0341C68.0302 25.4371 70.4289 27.4789 73.7489 27.4789C76.2555 27.4789 77.957 26.4331 78.704 24.3498L76.2472 23.3787ZM70.9269 20.7227C71.2008 19.5358 72.1885 18.8386 73.3754 18.8386C74.6702 18.8386 75.55 19.5358 75.55 20.6314L75.5334 20.7227H70.9269Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9066 16.7387H21.4673V18.822H17.9066V16.7387Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9066 19.6271H21.4673V21.7104H17.9066V19.6271Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9066 22.5155H21.4673V24.5988H17.9066V22.5155Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 25.4039H8.5607V27.4872H5V25.4039Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.29932 25.4039H12.86V27.4872H9.29932V25.4039Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6071 25.4039H17.1678V27.4872H13.6071V25.4039Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9066 25.4039H21.4673V27.4872H17.9066V25.4039Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6071 22.5155H17.1678V24.5988H13.6071V22.5155Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.29932 22.5155H12.86V24.5988H9.29932V22.5155Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.29932 19.6271H12.86V21.7104H9.29932V19.6271Z"
            fill={color}
        />
        <path 
            d="M85.1863 20.4488V20.7559H88V19.9342C88 18.0916 86.8463 16.7553 84.9124 16.7553C83.6674 16.7553 82.7876 17.3612 82.3311 18.3655V16.7553H79.4261V27.4872H82.3311V20.5733C82.3311 19.4777 82.9204 18.8718 83.8251 18.8718C84.6551 18.8801 85.1863 19.6603 85.1863 20.4488Z"
            fill={color}
        />
    </svg>
)

export default DeezerPlatformIcon;
